import React, { useCallback } from "react";
import classnames from "classnames";
import { useWindowDimensions } from "ceco-hooks";
import { Link } from "found";
import { Accordion } from "semantic-ui-react";
import AnimateHeight from "react-animate-height";
import { useTranslation } from "ceco-polyglot";

function Entry(props) {
  const t = useTranslation();
  const {
    data,
    auth,
    roleMode,
    expanded,
    setExpanded,
    index,
    activeAccordion,
    setActiveAccordion,
    className,
  } = props;
  const { name, icon, permissions, exact } = data;
  const { role } = auth?.user || false;
  const { windowWidth } = useWindowDimensions();
  const unexpandIfMobile = useCallback(() => {
    if (windowWidth < 768.99) {
      window.setTimeout(() => {
        setExpanded(false);
      }, 300);
    }
  }, [setExpanded, windowWidth]);
  const handleAccordionClick = () => {
    const active = activeAccordion === index ? -1 : index;
    setActiveAccordion(active);
    if (active === index) {
      setExpanded(true);
    }
  };
  if (roleMode && permissions.indexOf(role) < 0) {
    return null;
  }

  if (data.path) {
    return (
      <Link
        to={data.path}
        activeClassName="active"
        className={classnames(
          "cecoadmin-menu__entry",
          className,
          Link.props && Link.props.className
        )}
        onClick={unexpandIfMobile}
        {...(exact && { exact })}
      >
        <Item icon={icon} name={t(name)} expanded={expanded} />
      </Link>
    );
  } else if (data.children) {
    return (
      <>
        <Accordion.Title
          index={index}
          active={index === activeAccordion}
          onClick={handleAccordionClick}
          className={classnames("cecoadmin-menu__entry", className)}
        >
          <Item icon={icon} name={name} expanded={expanded} />
        </Accordion.Title>
        <AnimateHeight
          animateOpacity
          duration={300}
          height={index === activeAccordion ? "auto" : 0}
        >
          <Accordion.Content
            className="cecoadmin-menu__accordion-content"
            active={index === activeAccordion}
          >
            {data.children.map((content, i) => (
              <Link
                key={i}
                className={classnames(
                  "cecoadmin-menu__accordion-content_entry",
                  className
                )}
                to={content.path}
              >
                <Item
                  icon={content.icon}
                  name={content.name}
                  expanded={expanded}
                />
              </Link>
            ))}
          </Accordion.Content>
        </AnimateHeight>
      </>
    );
  }

  return null;
}

export default Entry;

const Item = ({ icon: Icon = () => null, name, expanded }) => {
  return (
    <>
      <Icon />
      <span className={classnames({ hidden: !expanded })}>{name}</span>
    </>
  );
};
